/* eslint-disable */

/**
 * Holds relevant information about a customer's onboarding state related to equity.
 *
 * @deprecated
 */
export interface EquityOnboardingState {
  /**
   * Note that if a teen has an active brokerage account, this implies they received approval from
   * a sponsor to invest.
   */
  has_active_brokerage_account?: boolean;
}

/** Holds relevant information about a customer's trading state related to equity. */
export interface TradingState {
  /**
   * Note that if a teen has an active brokerage account, this implies they received approval from
   * a sponsor to invest.
   */
  has_active_brokerage_account?: boolean;
  /** Sync value for the customer's dividend setting. */
  dividend_setting?: TradingStateDividendSetting;
  /**
   * Sync value to inform customers when their account transfer will be completed and they'll be able to trade.
   * A null value means that there is no account transfer currently in progress.
   */
  brokerage_account_transfer_estimated_completion?: Date;
}

/** Options for the customer's dividend setting. */
export enum TradingStateDividendSetting {
  /** UNDEFINED - Null state, i.e. customer has not set a dividend setting yet. */
  UNDEFINED = "UNDEFINED",
  SAVE = "SAVE",
  REINVEST = "REINVEST",
}
